/*
  innvolo-coleccion.js
  Dos cosas en la página de colección:

    1. Los filtros se aplican al marcar, sin pulsar «Aplicar». Sin este archivo
       el formulario sigue funcionando: por eso el botón existe en el HTML y
       solo se oculta cuando este script confirma que está vivo.

    2. La bandeja de cotización de varios productos. La selección se guarda en
       el navegador para que sobreviva al cambiar de colección — una dotación
       se arma con prendas de varias categorías.
*/

(function () {
  'use strict';

  var LLAVE = 'innvolo:cotizacion';

  /* ------------------------------------------------------------------
     1. Filtros
     ------------------------------------------------------------------ */

  var form = document.querySelector('[data-innvolo-filtros]');
  if (form) {
    /* La marca de que hay JS la pone el propio script: si falla, el botón
       «Aplicar» sigue visible y los filtros no se quedan inservibles. */
    form.dataset.innvoloAuto = 'si';

    form.addEventListener('change', function (ev) {
      if (ev.target.type === 'number') return; // el precio se envía al salir del campo
      form.requestSubmit ? form.requestSubmit() : form.submit();
    });

    form.querySelectorAll('input[type="number"]').forEach(function (campo) {
      campo.addEventListener('change', function () {
        form.requestSubmit ? form.requestSubmit() : form.submit();
      });
    });
  }

  var orden = document.querySelector('[data-innvolo-orden]');
  if (orden) {
    orden.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', orden.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }

  /* ------------------------------------------------------------------
     2. Bandeja de cotización
     ------------------------------------------------------------------ */

  var bandeja = document.querySelector('[data-innvolo-bandeja]');
  var botones = document.querySelectorAll('[data-innvolo-anadir]');
  if (!botones.length) return;

  function lee() {
    try {
      var crudo = window.localStorage.getItem(LLAVE);
      var lista = crudo ? JSON.parse(crudo) : [];
      return Array.isArray(lista) ? lista : [];
    } catch (e) {
      /* Modo incógnito o almacenamiento lleno: la bandeja sigue funcionando
         dentro de la página, solo que no recuerda al cambiar de colección. */
      return [];
    }
  }

  function guarda(lista) {
    try {
      window.localStorage.setItem(LLAVE, JSON.stringify(lista));
    } catch (e) {
      /* Sin persistencia, pero sin romper nada. */
    }
  }

  var sel = lee();

  function pinta() {
    /* Los botones reflejan lo guardado, incluso lo apartado en otra colección. */
    botones.forEach(function (b) {
      var dentro = sel.some(function (x) {
        return x.h === b.dataset.innvoloAnadir;
      });
      b.setAttribute('aria-pressed', String(dentro));
      b.setAttribute(
        'aria-label',
        (dentro ? 'Quitar ' : 'Añadir ') +
          b.dataset.innvoloTitulo +
          (dentro ? ' de' : ' a') +
          ' la cotización de varios productos'
      );
    });

    if (!bandeja) return;

    bandeja.dataset.innvoloAbre = sel.length ? 'si' : 'no';
    bandeja.querySelector('[data-innvolo-bandeja-n]').textContent = sel.length;
    bandeja.querySelector('[data-innvolo-bandeja-etiqueta]').textContent =
      sel.length === 1 ? 'producto en la cotización' : 'productos en la cotización';
    bandeja.querySelector('[data-innvolo-bandeja-lista]').textContent = sel
      .map(function (x) {
        return x.t;
      })
      .join(' · ');

    /* Los handles viajan a /pages/cotizar para precargarla. */
    var ir = bandeja.querySelector('[data-innvolo-bandeja-ir]');
    if (ir) {
      var base = ir.getAttribute('href').split('?')[0];
      ir.setAttribute(
        'href',
        sel.length
          ? base +
              '?productos=' +
              encodeURIComponent(
                sel
                  .map(function (x) {
                    return x.h;
                  })
                  .join(',')
              )
          : base
      );
    }
  }

  botones.forEach(function (b) {
    b.addEventListener('click', function () {
      var h = b.dataset.innvoloAnadir;
      var dentro = sel.some(function (x) {
        return x.h === h;
      });
      if (dentro) {
        sel = sel.filter(function (x) {
          return x.h !== h;
        });
      } else {
        sel.push({ h: h, t: b.dataset.innvoloTitulo });
      }
      guarda(sel);
      pinta();
    });
  });

  if (bandeja) {
    var vaciar = bandeja.querySelector('[data-innvolo-bandeja-vaciar]');
    if (vaciar) {
      vaciar.addEventListener('click', function () {
        sel = [];
        guarda(sel);
        pinta();
      });
    }
  }

  pinta();
})();
